import { Module } from 'vuex'
import { state } from './state'
import { actions } from './actions'
import { getters } from './getters'
import { mutations } from './mutations'
import { RootState } from 'store'
import { ProfileState } from './types'

export const profile: Module<ProfileState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}

